import { RichTextInput } from "ra-input-rich-text";
import React from "react";
import { BooleanInput, Edit, SimpleForm, TextInput } from "react-admin";
import { FileInput } from "../fileinputs/eventFileUpload";

export function InappEdit(props) {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="title" fullWidth />
        <RichTextInput source="description" fullWidth />
        <TextInput source="link" fullWidth />

        <FileInput
          title="Banner Image"
          add
          edit
          width="748px"
          height="248px"
          source={"adBannerImage"}
          route="inappAds/upload"
        />
        <FileInput
          title="Carousel Images"
          add
          edit
          source={"images"}
          route="inappAds/upload"
        />
        <BooleanInput source="isActive" />
        <BooleanInput source="directRedirection" />
      </SimpleForm>
    </Edit>
  );
}
